export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#camera-outline","viewBox":"0 0 32 32"}